import { useFormStore } from '../lib/store';
import AgreementModule from './modules/AgreementModule';
import ContactModule from './modules/ContactModule';
import ParticipantModule from './modules/ParticipantModule';
import RaceSelectionModule from './modules/RaceSelectionModule';
import ShirtSelectionModule from './modules/ShirtSelectionModule';
import MerchandiseModule from './modules/MerchandiseModule';
import PaymentModule from './modules/PaymentModule';
import ShippingModule from './modules/ShippingModule';
import NotesModule from './modules/NotesModule';
import CustomModule from './modules/CustomModule';

interface ModuleRendererProps {
  module: {
    id: string;
    type: string;
    name: string;
    nameEn?: string;
    icon?: string;
    headerStyle?: string;
    headerColor?: string;
    fields: any[];
    settings: any;
    isRepeatable?: boolean;
    showOnlyForCategories?: string[];
    conditional?: {
      fieldId: string;
      operator: string;
      value: any;
    };
  };
  event: any;
}

export default function ModuleRenderer({ module, event }: ModuleRendererProps) {
  const { selectedCategoryId } = useFormStore();

  // Check showOnlyForCategories filter
  if (module.showOnlyForCategories && module.showOnlyForCategories.length > 0) {
    if (!selectedCategoryId || !module.showOnlyForCategories.includes(selectedCategoryId)) {
      return null;
    }
  }

  const props = { module, event };

  switch (module.type) {
    case 'agreement':
      return <AgreementModule {...props} />;
    case 'contact':
      return <ContactModule {...props} />;
    case 'participant':
      return <ParticipantModule {...props} />;
    case 'race_selection':
      return <RaceSelectionModule {...props} />;
    case 'shirt_selection':
      return <ShirtSelectionModule {...props} />;
    case 'merchandise':
      return <MerchandiseModule {...props} />;
    case 'payment':
      return <PaymentModule {...props} />;
    case 'shipping':
      return <ShippingModule {...props} />;
    case 'notes':
      return <NotesModule {...props} />;
    default:
      return <CustomModule {...props} />;
  }
}
